import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 34 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 44\" id=\"icon-trash\"><path d=\"M2.5 38.917a4.848 4.848 0 0 0 4.833 4.833h19.334a4.848 4.848 0 0 0 4.833-4.833v-29h-29v29zm31.417-36.25h-8.459L23.042.25H10.958L8.542 2.667H.083V7.5h33.834V2.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol